import styles from "./LimitCurrencySelector.module.css";
import LimitCurrencyQuantity from "../LimitCurrencyQuantity/LimitCurrencyQuantity";
import { RiArrowDownSLine } from "react-icons/ri";
import { useCallback, useState } from "react";
import Modal from "../../misc/modal/Modal";
import TokenSelect from "../../swap/tokenSelect/TokenSelect";
import { uniDefaultTokenList } from "../../../data/tokens";
import Toggle from "../../misc/toggle/Toggle";

const LimitCurrencySelector = (props) => {
  const { direction, field_Id } = props;
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const tokensList = uniDefaultTokenList.tokens;

  const openModal = useCallback(() => {
    setShowModal(true);
  }, [setShowModal]);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);

  const searchInput = (
    <div className={styles.search_input}>
      <input
        type="text"
        placeholder="Search name or paste address"
        onChange={(event) => setSearchTerm(event.target.value)}
      />
    </div>
  );

  const modalContent = (
    <div className={styles.pool_modal}>
      {searchInput}
      {tokensList
        .filter((val) => {
          if (searchTerm === "") {
            return val;
          } else if (
            val.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            val.symbol.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return val;
          }
        })
        .map((token, idx) => {
          return (
            <TokenSelect
              key={idx}
              icon={token.logoURI}
              symbol={token.symbol}
              name={token.name}
              qty={token.decimals}
            />
          );
        })}
    </div>
  );
  const ModalOrNull = showModal ? (
    <Modal onClose={closeModal} title="Choose Coin" content={modalContent} />
  ) : null;

  const DexBalanceContent = (
    <span className={styles.surplus_toggle}>
      Use DEX balance
      <div className={styles.toggle_container}>
        <Toggle
          isOn={isChecked}
          handleToggle={() => setIsChecked(!isChecked)}
          Width={40}
          id="surplus_liquidity"
        />
      </div>
    </span>
  );

  const WithdrawTokensContent = (
    <span className={styles.surplus_toggle}>
      Withdraw tokens
      <div className={styles.toggle_container}>
        <Toggle
          isOn={isChecked}
          handleToggle={() => setIsChecked(!isChecked)}
          Width={40}
          id="tokens_withdrawal"
        />
      </div>
    </span>
  );
  return (
    <div className={styles.swapbox}>
      <span className={styles.direction}>{direction}</span>
      <div className={styles.swapbox_top}>
        <div className={styles.swap_input}>
          <LimitCurrencyQuantity field_Id={field_Id} />
        </div>
        <div className={styles.token_select} onClick={openModal}>
          <img
            className={styles.token_list_img}
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Ethereum-icon-purple.svg/480px-Ethereum-icon-purple.svg.png"
            alt="ethreum"
            width="30px"
          />
          <span className={styles.token_list_text}>ETH</span>
          <RiArrowDownSLine  size={27} />
        </div>
      </div>
      <div className={styles.swapbox_bottom}>
        {field_Id === "limit-sell" ? (
          <span>Wallet: 69.420 | DEX: 0.00</span>
        ) : (
          <span>Wallet: 0.00 | Surplus: 69.0</span>
        )}
        {field_Id === "limit-sell" ? DexBalanceContent : WithdrawTokensContent}
      </div>
      {ModalOrNull}
    </div>
  );
};

export default LimitCurrencySelector;
